import { Alert, Typography } from '@mui/material';
import { useFormikContext } from 'formik';
import { filter, isEmpty, map } from 'lodash';
import React, { Fragment } from 'react';
import { useTranslation } from 'react-i18next';

import { FormikArray, P2PProviderSelect } from 'components';
import { useP2PProvidersTradeMethods } from 'hooks';
import { TranslationNamespace } from 'i18n';
import { P2P_PROVIDER_DIRECTION_ANY } from 'utils';

import { Values } from '../ManageShop';

type Props = {
  assetCurrencyIds?: string[];
  tradeMethodsIds: string[];
};

export const ShopP2PProviders: React.FC<Props> = ({
  assetCurrencyIds,
  tradeMethodsIds,
}) => {
  const { t } = useTranslation(TranslationNamespace.Common, {
    keyPrefix: 'features.shops.manage',
  });
  const formik = useFormikContext<Values>();
  const { tradeMethodsByProviderId } = useP2PProvidersTradeMethods();

  return (
    <Fragment>
      <Typography variant="subtitle1">
        {t('sections.p2p_providers.title')}
      </Typography>
      {isEmpty(tradeMethodsIds) && (
        <Alert severity="info">
          {t('alerts.p2p_providers_require_trade_methods')}
        </Alert>
      )}
      <FormikArray
        addItemLabel={t('buttons.add_p2p_provider')}
        name="p2pProvidersConfigs"
        sortable
        removable
        defaultValue={{ p2pProviderId: '' }}
        ItemComponent={({ item, index }) => {
          const exclude = map(
            filter(
              formik.values.p2pProvidersConfigs,
              (config) => config.p2pProviderId !== item.p2pProviderId,
            ),
            (t) => t.p2pProviderId,
          );
          return (
            <P2PProviderSelect
              // assetCurrencyIds={assetCurrencyIds}
              exclude={exclude}
              tradeMethodsIds={tradeMethodsIds}
              tradeMethodsByProviderId={tradeMethodsByProviderId}
              sx={{ mr: 1, flex: 1 }}
              direction={P2P_PROVIDER_DIRECTION_ANY}
              name={`p2pProvidersConfigs[${index}].p2pProviderId`}
              label={t('fields.p2p_provider')}
            />
          );
        }}
      />
    </Fragment>
  );
};
